import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="home" className="py-16 bg-bkash-white">
      <div className="container mx-auto px-4 text-center">
        {/* ASCII Art Logo - Responsive */}
        <div className="mb-8 font-mono text-bkash-red overflow-x-auto">
          {/* Desktop/Tablet ASCII Art */}
          <pre className="whitespace-pre hidden md:block text-sm lg:text-base">
{`
  ████████╗███████╗██╗  ██╗███╗   ██╗██╗   ██╗██████╗  █████╗ 
  ╚══██╔══╝██╔════╝██║ ██╔╝████╗  ██║██║   ██║██╔══██╗██╔══██╗
     ██║   █████╗  █████╔╝ ██╔██╗ ██║██║   ██║██████╔╝███████║
     ██║   ██╔══╝  ██╔═██╗ ██║╚██╗██║██║   ██║██╔══██╗██╔══██║
     ██║   ███████╗██║  ██╗██║ ╚████║╚██████╔╝██║  ██║██║  ██║
     ╚═╝   ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝
`}
          </pre>
          
          {/* Mobile ASCII Art - Simplified */}
          <pre className="whitespace-pre md:hidden text-xs">
{`
████████╗███████╗██╗  ██╗███╗   ██╗██╗   ██╗██████╗  █████╗
╚══██╔══╝██╔════╝██║ ██╔╝████╗  ██║██║   ██║██╔══██╗██╔══██╗
   ██║   █████╗  █████╔╝ ██╔██╗ ██║██║   ██║██████╔╝███████║
   ██║   ██╔══╝  ██╔═██╗ ██║╚██╗██║██║   ██║██╔══██╗██╔══██║
   ██║   ███████╗██║  ██╗██║ ╚████║╚██████╔╝██║  ██║██║  ██║
   ╚═╝   ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝
`}
          </pre>
        </div>

        {/* Main Heading */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold text-bkash-dark mb-6 border-b-4 border-bkash-red pb-4">
          INNOVATIVE TECH SOLUTIONS
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl text-bkash-gray mb-8 max-w-3xl mx-auto px-4">
          Building the future with cutting-edge technology solutions for modern businesses
        </p>

        {/* Company Description */}
        <div className="bg-bkash-bg border-2 border-bkash-border p-4 sm:p-6 mb-8 max-w-4xl mx-auto rounded-lg mx-4">
          <p className="text-base sm:text-lg text-bkash-dark mb-4">
            Welcome to TEKNURA - Your trusted partner in digital transformation. 
            We specialize in creating robust, scalable, and innovative software solutions 
            that drive business growth and operational efficiency.
          </p>
          <p className="text-sm sm:text-base text-bkash-gray">
            From e-commerce platforms to enterprise management systems, 
            we deliver solutions that meet the highest standards of quality and performance.
          </p>
        </div>

        {/* Call to Action */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
          <a 
            href="#services" 
            className="w-full sm:w-auto bg-bkash-red text-bkash-white px-6 sm:px-8 py-3 font-bold border-2 border-bkash-red hover:bg-transparent hover:text-bkash-red transition-colors rounded text-center"
          >
            EXPLORE SERVICES
          </a>
          <a 
            href="#contact" 
            className="w-full sm:w-auto border-2 border-bkash-red text-bkash-red px-6 sm:px-8 py-3 font-bold hover:bg-bkash-red hover:text-bkash-white transition-colors rounded text-center"
          >
            GET IN TOUCH
          </a>
        </div>

        {/* Status Bar */}
        <div className="mt-12 bg-bkash-bg border border-bkash-border p-4 max-w-2xl mx-auto rounded mx-4">
          <div className="flex flex-col sm:flex-row justify-between items-center text-sm gap-2 sm:gap-0">
            <span className="text-bkash-red font-bold">STATUS: ONLINE</span>
            <span className="text-bkash-blue">VERSION: 2.0.24</span>
            <span className="text-bkash-gray">UPTIME: 99.9%</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
